export default __webpack_public_path__ + "db0ff66930a5161222562894571bfabc.png";